// Auto-generated from gen_ce_info_and_maps.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { CEMap } from '../types/ce';

import BozjaCEs from './bozja_encounters';

const data: CEMap<typeof BozjaCEs> = {
  '1CA': 'TheHuntForRedChoctober',
  '1CB': 'MetalFoxChaos',
  '1CC': 'TheBayingOfTheHounds',
  '1CD': 'TheShadowOfDeathsHand',
  '1CE': 'TrampledUnderHoof',
  '1D0': 'VigilForTheLost',
  '1D1': 'PatriotGames',
  '1D2': 'AcesHigh',
  '1D3': 'AndTheFlamesWentHigher',
  '1D4': 'KillItWithFire',
  '1D5': 'TheFinalFurlong',
  '1D6': 'TheFiresOfWar',
  '1D7': 'TheBattleOfCastrumLacusLitore',
  '1DB': 'BeastOfMan',
  '1DC': 'WhereStrodeTheBehemoth',
  '1DF': 'RiseOfTheRobots',
} as const;

export default data;
